import { DependencyList, EffectCallback, useEffect } from "react";

export const useDebounce = (
    callback: EffectCallback,
    timeoutMs: number,
    dependencies: DependencyList,
) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            callback();
        }, timeoutMs);
  
        return () =>
            clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};
